import { createSelector } from "@reduxjs/toolkit";

import { Map } from "@/utils";

export default createSelector(
    ({ map }) => map.values.global.present.lights,
    ({ map }) => map.general.settings,
    (lights, settings) => {
        const { operatingPoint, positioningType } = settings.fixtureDetails;
        const hasPositioningType = (v) =>
            positioningType.toLowerCase().includes(v);
        const maxMountingHeight = Map.Converter.convertFeetToMeters(
            settings.fixtureDetails.maxMountingHeight,
            4,
        );
        const jsonFile = {
            maxMountingHeight,
            operatingPoint,
            fixtureType: null,
            hasVLC: hasPositioningType("vlc"),
            hasBLEBeacons: hasPositioningType("ble"),
            lights: Object.keys(lights).map((lightId) => {
                const light = lights[lightId];
                const {
                    luminairePositionId,
                    tag,
                    id,
                    BLEBeaconId,
                    BLEBeaconUUId,
                    x1,
                    x2,
                    x3,
                    y1,
                    y2,
                    y3,
                    z,
                    floorSpaceCatalog_ID,
                    flagNotes,
                    controlGroupId,
                    externalLength,
                    externalWidth,
                    VLCEnabled,
                    luminaireTypeDisplayName,
                    luminaireType_ID: luminaireTypeID,
                    ciCode,
                    locationDescription,
                } = light.convertToAPI();
                return {
                    luminairePositionId,
                    tag,
                    id,
                    BLEBeaconId,
                    BLEBeaconUUId,
                    x1,
                    x2,
                    x3,
                    y1,
                    y2,
                    y3,
                    z,
                    floorSpaceCatalog_ID,
                    flagNotes,
                    controlGroupId,
                    externalLength,
                    externalWidth,
                    VLCEnabled,
                    luminaireTypeDisplayName,
                    luminaireTypeID,
                    ciCode,
                    locationDescription,
                };
            }),
        };
        return jsonFile;
    },
);
